import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import LandingPage from './pages/LandingPage'
import SignupPage from './pages/SignupPage'
import PaymentPage from './pages/PaymentPage'
import ConfirmationPage from './pages/ConfirmationPage'
import TermsOfService from './pages/TermsOfService'
import PrivacyPolicy from './pages/PrivacyPolicy'
import DataProcessingAddendum from './pages/DataProcessingAddendum'
import HelpCenter from './pages/HelpCenter'
import SetupGuide from './pages/SetupGuide'

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/dpa" element={<DataProcessingAddendum />} />
        <Route path="/help-center" element={<HelpCenter />} />
        <Route path="/setup-guide" element={<SetupGuide />} />
      </Routes>
    </Router>
  )
}

export default App
